import { gql } from "@apollo/client";

export const SOV_CAMPAIGN_PERCENTAGE = gql`
  query sovCampaign(
    $listing_id: Int!
    $daily_budget: Float!
    $campaign_category: SovCampaignCategoryEnum!
    $radius: Int
  ) {
    SovCampaign {
      calculateViewPercentages(
        listing_id: $listing_id
        daily_budget: $daily_budget
        campaign_category: $campaign_category
        radius: $radius
      ) {
        city_view_percentage
        district_view_percentage
        radius_view_percentage
      }
    }
  }
`;
export const SOV_CAMPAIGN_LIST = gql`
  query sovCampaignList($listing_id: Int, $status: SovCampaignStatusEnum) {
    SovCampaign {
      list(status: $status, listing_id: $listing_id) {
        list {
          id
          listing_id
          listing_title
          listing_imgs
          user_id
          daily_budget
          next_daily_budget
          campaign_category
          status
          start_datetime
          end_datetime
          first_activation_date
          created_at
          updated_at
        }
        total
      }
    }
  }
`;

export const SOV_CAMPAIGN_DETAILS = gql`
  query getFullCampaignDetails($id: Int!) {
    SovCampaign {
      getFullCampaignDetails(sov_campaign_id: $id) {
        sov_campaign {
          id
          listing_id
          user_id
          daily_budget

          next_daily_budget
          campaign_category
          status
          start_datetime
          end_datetime
          listing_id
          created_at
          updated_at
        }
        listing {
          id
          price
          title
          imgs
          content
          published
          beds
          wc
          livings
          type
          area
          category
          location {
            lng
            lat
          }
        }
        sov_daily_stats {
          budget
          views
          calls
          screens
          whatsapp
          favorited
          msgs
          answers
          shared
          impressions
          start_datetime
          end_datetime
        }
      }
      list {
        list {
          id
          listing_id
          listing_title
          listing_imgs
          user_id
          daily_budget
          next_daily_budget
          campaign_category
          status
          start_datetime
          end_datetime
          created_at
          updated_at
        }
        total
      }
    }
  }
`;

export const CREATE_SOV_CAMPAIGN = gql`
  mutation createSovCampaign(
    $listing_id: Int!
    $daily_budget: Float!
    $campaign_category: SovCampaignCategoryEnum!
    $start_datetime: Float!
    $end_datetime: Float!
  ) {
    SovCampaign {
      create(
        data: {
          listing_id: $listing_id
          daily_budget: $daily_budget
          campaign_category: $campaign_category
          start_datetime: $start_datetime
          end_datetime: $end_datetime
        }
      ) {
        id
        listing_id
        daily_budget
        next_daily_budget
        campaign_category
        status
      }
    }
  }
`;
export const CALC_MIN_PRESET_SOV = gql`
  query calcMinPreset($id: Int!) {
    SovCampaign {
      calculateMinimumAndPresetPrices(listing_id: $id) {
        minimum
        preset
      }
    }
  }
`;
export const UPDATE_SOV_CAMPAIGN = gql`
  mutation updateCampaign(
    $id: Int!
    $daily_budget: Float!
    $end_datetime: Float!
  ) {
    SovCampaign {
      update(
        sov_campaign_id: $id
        data: { daily_budget: $daily_budget, end_datetime: $end_datetime }
      ) {
        message
      }
    }
  }
`;
export const ACTIVATE_SOV_CAMPAIGN = gql`
  mutation activateSovCampaign($id: Int!) {
    SovCampaign {
      activate(sov_campaign_id: $id) {
        message
      }
    }
  }
`;

export const STOP_SOV_CAMPAIGN = gql`
  mutation stopSovCampaign($id: Int!) {
    SovCampaign {
      stop(sov_campaign_id: $id) {
        message
      }
    }
  }
`;

export const GET_KEVEL_EJAR_CONTRACT = gql`
  query sovCampaignList($site_id: KevelDecisionSiteIds, $lang: Langs) {
    Kevel {
      ejarContractPubDecision(site_id: $site_id, lang: $lang) {
        link
        img
        impression_url
        name
        rating
        rating_count
      }
    }
  }
`;

export const GET_EJAR_CONTRACTS_TYPES = gql`
  query {
    Offices {
      Ejar {
        getFees {
          createdAt
          updatedAt
          type_id
          name
          value
          transaction_category
          description
          category_name
        }
      }
    }
  }
`;

export const WRITE_BROKER_REVIEW = gql`
  mutation writeBrokerReview($flow_id: Int!, $a_id: String!, $review: String!) {
    User {
      writeBrokerReview(a_id: $a_id, flow_id: $flow_id, review: $review)
    }
  }
`;
